import {FormControl, MenuItem, Select, FormHelperText} from "@mui/material";
import React, {useEffect} from "react";
import style from "../../assets/css/global-fields.module.scss";

const GlobalSelectField = ({
  labelId,
  value,
  label,
  onChange,
  onBlur,
  error,
  helperText,
  menuItems,
  isStateOrCity = false,
  disabled = false,
  cssClass,
  ref = null,
  placeH = null,
  isAgent = false,
  isPolicy = false,
}) => {
  useEffect(() => {
    const nativeInputs = document.querySelectorAll(".MuiSelect-nativeInput");
    nativeInputs.forEach((input) => {
      input.setAttribute("aria-label", "select");
    });
  }, []);

  return (
    <div className={style.proposalSelectField}>
      <FormControl fullWidth className="global-select" error={error}>
        <Select
          labelId={labelId}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          className={cssClass || "  "}
          ref={ref}
          renderValue={(selected) => {
            if (!selected && placeH) {
              return <>{placeH}</>;
            }
            if (isAgent && selected) {
              const cli_ent = menuItems.find((c) => c?.user_id == selected);
              return <>{`${cli_ent.first_name} ${cli_ent.last_name}`}</>;
            }
            if (isPolicy && selected) {
              const poli_cy = menuItems.find((p) => p?.value == selected);
              return <>{poli_cy?.name}</>;
            }
            return selected;
          }}
          displayEmpty
        >
          {isAgent
            ? menuItems?.map((item) => (
                <MenuItem key={item.user_id} value={item.user_id}>
                  <div style={{display: "flex", flexDirection: "column"}}>
                    <p>{`${item.first_name} ${item.last_name}`}</p>
                    <small>{item?.email}</small>
                  </div>
                </MenuItem>
              ))
            : isStateOrCity
              ? menuItems?.map((item) => (
                  <MenuItem key={item.name} value={item.name}>
                    {item.name}
                  </MenuItem>
                ))
              : menuItems?.map((item) => (
                  <MenuItem key={item.name} value={item.value}>
                    {item.name}
                  </MenuItem>
                ))}
        </Select>
        {error && (
          <FormHelperText style={{color: "#d32f2f"}}>
            {helperText}
          </FormHelperText>
        )}
      </FormControl>
    </div>
  );
};

export default GlobalSelectField;
